module.exports = __webpack_public_path__ + "static/assets/a26b71949a0094f85b0e4e86189a000f.svg";